export default __webpack_public_path__ + "static/media/Group 386.084384ec.svg";